import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

import DataSourceIcon from "../../Components/DataSourcesPanel";

const EngagementHighlightsSignalsCard = ({
  theme,
  highlights,
  entityId,
  AiSectionFeedback,
  requestId,
  uiSectionKey,
  userEmail,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 10px 25px rgba(15,23,42,0.10)",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
            gap: 2,
            mb: 1.5,
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <TaskAltIcon sx={{ color: theme.palette.primary.main }} />

            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                fontSize: "1rem",
                color: theme.palette.primary.main,
              }}
            >
              Engagement Highlights
            </Typography>

            <DataSourceIcon
              mode="light"
              sources={["Salesforce", "Web Search"]}
            />
          </Box>

          <AiSectionFeedback
            sectionName="ClientEngagement - Highlights Identified by AI"
            entityId={entityId}
            variant="light"
            requestId={requestId}
            uiSectionKey={uiSectionKey}
            userEmail={userEmail}
          />
        </Box>

        {/* FULL WIDTH HIGHLIGHTS */}
        <Box
          sx={{
            width: "100%",
            border: "1px solid #e5e7eb",
            borderRadius: 2,
            p: 2,
            bgcolor: "#ffffff",
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "0.95rem",
              color: "#111827",

              mb: 1.5,
            }}
          >
            Key Highlights from Last Meetings
          </Typography>

          <Box
            sx={{
              maxHeight: { xs: 360, lg: 380 },
              overflowY: "auto",
              pr: 1,
            }}
          >
            {highlights?.length > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                {highlights.map((h, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      width: { xs: "100%", md: "48%" }, // ✅ max 2 per row
                      border: "1px solid #e5e7eb",
                      borderRadius: 2,
                      p: 2,
                      bgcolor: "#fafafa",
                      boxShadow: "0 6px 16px rgba(15,23,42,0.04)",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: "0.9rem",
                        color: "#111827",
                        mb: 1,
                      }}
                    >
                      {h.meeting_type} — {h.date}
                    </Typography>

                    <List dense disablePadding sx={{ m: 0 }}>
                      {(h.bullets || []).map((b, id2) => (
                        <ListItem key={id2} sx={{ py: 0.35 }}>
                          <ListItemIcon sx={{ minWidth: 26 }}>
                            <ArrowRightAltIcon
                              sx={{
                                fontSize: 16,
                                color: theme.palette.primary.main,
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={b}
                            primaryTypographyProps={{
                              fontSize: "0.82rem",
                              color: "#374151",
                              lineHeight: 1.35,
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography sx={{ fontSize: "0.8rem", color: "#6b7280" }}>
                —
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default EngagementHighlightsSignalsCard;
